const filterSelect = document.getElementById('posts-list-filter-form-months');

if(filterSelect) {
    filterSelect.addEventListener('change',function(e) {
        this.closest('form').submit();
    });
}
